<template>
  <footer>
    <div class="footer">
      <to-top-button class="top"></to-top-button>
      <div class="body-9 flex items-center">
        <div class="col-1"></div>
        <div class="col-3">
          <a :href="corporateSiteUrl" target="_blank">
            <img class="logo" alt='logo' src="../assets/images/1-lrn-logo-190.svg"/>
          </a>
        </div>
        <div class="col-8 px-0">
          <nav>
            <ul class="list-reset flex">
              <li class="col-3 text-center" v-for="page in footerPages" :key="page.id">
                <router-link :key="page.id" :to="{name: 'page', params: {page: page.slug }}" class="text-grey-4">{{ page.title }}</router-link>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
    <div class="sub-footer legal flex items-center">
      <div class="col-1"></div>
      <div class="col-7 legal-1">
        <p class="text-f1-d mb-0">Copyright © {{ copyrightYear }} by Lerner Publishing Group, Inc. Lerner™ Sports and Lerner™ Sports logo are all property of Lerner Publishing Group, Inc. and may not be reproduced or repurposed without the written permission of Lerner Publishing Group, Inc. All Rights Reserved.</p>
      </div>
      <div class="col-2 text-center legal-1">
        <a :href="`${corporateSiteUrl}/terms`" target="_blank" class="text-f1-d">Terms</a>
      </div>
      <div class="col-2 text-center legal-1">
        <a :href="`${corporateSiteUrl}/privacy`" target="_blank" class="text-f1-d">Privacy Policy</a>
      </div>
    </div>
  </footer>
</template>

<script>
  import ToTopButton from '@/component/ToTopButton';

  export default {
    name: 'AppFooter',

    components: {
      ToTopButton
    },

    props: ['pages'],

    data: function() {
      return {
        copyrightYear: new Date().getFullYear(),
        corporateSiteUrl: process.env.VUE_APP_LERNER_CORPORATE_URL
      };
    },

    methods: {
      sortPages: function (a, b) {
        if (a.menu_order < b.menu_order) {
          return -1;
        }

        if (a.menu_order > b.menu_order) {
          return 1;
        }

        return 0;
      }
    },

    computed : {
      footerPages: function () {
        return this.pages.sort(this.sortPages).filter(page => page.title.toLowerCase() !== 'home');
      }
    }
  }
</script>

<style lang="scss" scoped>
  .footer {
    @apply border-t-6 border-f1-b bg-f1-a border-solid relative mt-8 py-6;

    &:before {
      content: '';
      position: absolute;
      width: 100%;
      height: 16px;
      left: 0;
      top: -22px;
      background: linear-gradient(to bottom, rgba(0,0,0,0) 0%,rgba(0,0,0,0.1) 100%);
    }

    .top {
      width: 40px;
      height: 40px;
      position: absolute;
      top: -20px;
      left: 50%;
      transform: translateX(-50%);
    }

    .logo {
      width: 190px;
      height: 36px;
    }
  }

  .sub-footer {
    @apply py-3 bg-f1-c;
  }
</style>
